var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagThailand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4316C24.8366 32.4316 32 25.2682 32 16.4316C32 7.59508 24.8366 0.431641 16 0.431641C7.16344 0.431641 0 7.59508 0 16.4316C0 25.2682 7.16344 32.4316 16 32.4316Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0048 10.8662H0.995188C0.352 12.5995 0 14.4743 0 16.4314C0 18.3885 0.352 20.2633 0.995188 21.9966H31.0049C31.648 20.2633 32 18.3885 32 16.4314C32 14.4743 31.648 12.5995 31.0048 10.8662Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0.431641C11.1506 0.431641 6.80537 2.58939 3.87119 5.99683H28.1287C25.1946 2.58939 20.8494 0.431641 16 0.431641Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1288 26.8662H3.87119C6.80537 30.2736 11.1506 32.4314 16 32.4314C20.8494 32.4314 25.1946 30.2736 28.1288 26.8662Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.431641)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagThailand);
export default __webpack_public_path__ + "static/media/flag_thailand.d8b6524ecb0205320489255b5cd13637.svg";
export { ForwardRef as ReactComponent };